module.exports = __webpack_public_path__ + "static/media/ic_clipboard.9abf778e.svg";